import { useHistory, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import {API_BASE_URL} from '../plugins/axios';
import { TResponse, UserInfo } from '../types/types';
import axios from 'axios';

const authToken = localStorage.getItem('authToken');

const UserCheck = () => {
  const { to } = useParams<{ to: string }>();
  const history = useHistory();

  useEffect(() => {
    axios
      .get<TResponse<UserInfo>>(
        `${API_BASE_URL}/v1/users/info`,
        {
          withCredentials: true,
          headers: { Authorization: `bearer ${authToken}` },
        },
      )
      .then(r => history.replace(`/${to.replaceAll('+', '/')}`))
      .catch(e => history.replace('/login'));
  }, [to]);

  return <></>;
};

export default UserCheck;
